export function isNullOrUndefined(value: string | number) {
  return value === null || value === undefined || value === '';
}
